// extracted by mini-css-extract-plugin
module.exports = {"tab_container":"TabContainer_tab_container__rdfS6","tabs":"TabContainer_tabs__PStha","tab_sections":"TabContainer_tab_sections__1vOa5","tab_panel":"TabContainer_tab_panel__08wWN"};